














































import FilterGroupFilterCombi from '@/classes/filter-group-filter-combi.model';
import Translations from '@/models/translations.model';
import PredefinedFilterItem from '@/models/predefined-filter-item.model';

export default {
  name: "ActiveFilters",
  data() {
    return {
      filterBarElement: null,
    };
  },
  computed: {
    predefinedFilterItems(): Array<PredefinedFilterItem> {
      return this.$store.state.predefinedFilterItems;
    },
    selectedFilters(): Array<FilterGroupFilterCombi> {
      return this.$store.state.selectedFilters;
    },
    translations(): Translations {
      return this.$store.state.translations;
    },
  },
  watch: {
    selectedFilters() {
      setTimeout(() => {
        // timeout is required to wait for Vue to update the DOM
        this.initFilterBar();
      }, 150);
    },
  },
  methods: {
    unselectPredefinedFilterItem(predefinedFilterItem: PredefinedFilterItem) {
      this.$store.dispatch("unselectPredefinedFilterItem", predefinedFilterItem);
    },
    unselectFilter(filterGroupFilterCombi: FilterGroupFilterCombi) {
      this.$store.dispatch("unselectProductFilter", filterGroupFilterCombi);
    },
    loadFilterBar() {
      this.filterBarElement = this.$el.querySelector(".flt-active-filter-bar");
      Miele.ModuleLoader.createModuleInstance("elements/filter/active-filter-bar", this.filterBarElement);
    },
    initFilterBar() {
      this.filterBarElement?.instance?.init();
    },
  },
  mounted() {
    this.loadFilterBar();
  }
};
